module.exports = __webpack_public_path__ + "img/Final_BizOpsLogo.b08c9be2.svg";